import {BaseWidgetProps} from '../../../widget-container';
import {NavigationState} from '../../../../common/navigator';
import {Article} from '@wix/answers-api';
import * as React from 'react';
import { deserialize } from '@wix/answers-article-html-serdes';
import {ComponentsViewer} from '@wix/answers-common-components';
import { isInternalLink } from '../is-internal-link';
import { scrollIntoView } from '../../../../common/utils';

const AnswersComponentViewer: any = ComponentsViewer;

export type ArticleViewProps = {
	article: Article;
	baseConfig: BaseWidgetProps;
};

export class ArticleView extends React.Component<ArticleViewProps, any> {
	contentElem: HTMLDivElement | null = null;

	anchorManipulation () {
		const contentElem = document.getElementById('article-content');
		const anchors = contentElem ? Array.prototype.slice.call(contentElem.getElementsByTagName('a')) : [];
		if (anchors && anchors.forEach) {
			anchors.forEach((aElement: HTMLAnchorElement) => {
				const url = aElement.getAttribute('href') || '';
				// this is hacky and error prone, relies on having one single help center and not changing the help center domain
				const currArticleHost = new URL(this.props.article.url).host;
				const internalLinkData = isInternalLink(url, currArticleHost);

				if (internalLinkData) {
					const uriPart = url.split('/').pop() || '';
					aElement.addEventListener('click', (e) => {
						e.preventDefault();
						this.props.baseConfig.widgetNavigator.goToState(NavigationState.articleUri, uriPart);
					});
				} else {
					aElement.setAttribute('target', '_blank');
				}
			});
		}
	}

	onImageLoad (imgElement: HTMLImageElement) {
		const imgWidth = imgElement.naturalWidth;
		const widgetWidht = window.innerWidth;
		if (imgWidth > widgetWidht) {
			imgElement.onclick = (e: any) => {
				const src = imgElement.getAttribute('src') || '';
				if (parent) {
					e.stopPropagation();
					parent.postMessage({imageSrc: src}, '*');
				}
			};
		}
	}

	imageManipulation () {
		const contentElem = document.getElementById('article-content');
		const imgs = contentElem ? Array.prototype.slice.call(contentElem.getElementsByTagName('img')) : [];
		if (imgs && imgs.forEach) {
			imgs.forEach((imgElement: HTMLImageElement) => {
				imgElement.onload = () => this.onImageLoad(imgElement);
			});
		}
	}

	maybeScrollToAnchor = () => {
		if (location.hash && this.contentElem) {
			const anchorElem = this.contentElem.querySelector<HTMLElement>(location.hash);
			if (anchorElem) {
				scrollIntoView(anchorElem, {align: {top: 0, topOffset: 50}});
			}
		}
	}

	componentDidMount () {
		this.anchorManipulation();
		this.imageManipulation();
		this.maybeScrollToAnchor();
	}

	render () {
		const components = deserialize(this.props.article.content, this.props.article.locale);

		return (
			<div className='article-view'>
				<div className='title'>{this.props.article.title}</div>
				<div className='content' id='article-content' ref={(content) => { this.contentElem = content; }}>
					<AnswersComponentViewer components={components} locale={this.props.article.locale} />
				</div>
			</div>
		);
	}
}
